//#region src/kiosk_peripheral_connection_state.ts
var KioskPeripheralConnectionState = /* @__PURE__ */ function(KioskPeripheralConnectionState) {
	KioskPeripheralConnectionState[KioskPeripheralConnectionState["DISCONNECTED"] = 0] = "DISCONNECTED";
	KioskPeripheralConnectionState[KioskPeripheralConnectionState["CONNECTING"] = 1] = "CONNECTING";
	KioskPeripheralConnectionState[KioskPeripheralConnectionState["CONNECTED"] = 2] = "CONNECTED";
	return KioskPeripheralConnectionState;
}(KioskPeripheralConnectionState || {});
//#endregion
export { KioskPeripheralConnectionState };

//# sourceMappingURL=kiosk_peripheral_connection_state.js.map